import Calendar from './Calendar';
import { registerComponent } from '../index';
export default Calendar;
registerComponent('calendar', Calendar);
